import type { ControlModeRequest, ControlModeResponse, WatcherStatus } from "@/types/control";
import { mutate } from "@/api/mutate";
import { request } from "@/api/request";

const WATCHER_BASE_URL = import.meta.env.VITE_WATCHER_BASE_URL;

export async function fetchStatus(): Promise<WatcherStatus> {
  const body = await request<WatcherStatus>(WATCHER_BASE_URL, "/api/status");
  if (!body) throw new Error("Malformed /api/status response");
  return body;
}

export async function postControlMode(input: ControlModeRequest): Promise<ControlModeResponse> {
  return mutate<ControlModeResponse>(WATCHER_BASE_URL, "/api/control/mode", input);
}
